import ElectronScreenShareRepository from "../Repositories/ScreenShare/ElectronScreenShareRepository";
import type {
  ScreenShareRepository,
  ScreenShareSource,
} from "../Repositories/ScreenShare/ScreenShareRepository.interface";
import ApiScreenShareRepository from "../Repositories/ScreenShare/ApiScreenShareRepository";

type ScreenShareServiceType = "api";

class ScreenShareService {
  private type: ScreenShareServiceType = "api";
  private Repository!: ScreenShareRepository;

  constructor(type: ScreenShareServiceType = "api") {
    this.type = type;
    this.assignRepository();
  }

  private assignRepository() {
    switch (this.type) {
      case "api":
        this.Repository = new ApiScreenShareRepository();
        break;
      default:
        this.Repository = new ElectronScreenShareRepository();
    }
  }

  async getSources(): Promise<ScreenShareSource[]> {
    return await this.Repository.getSources();
  }
}

export default ScreenShareService;
